import axios from 'axios';

const isAdmin = process.env.VUE_APP_ADMIN == '1' ? true : false;

function getToken() {
  const token = localStorage.getItem('token')
  return token 
}

function getTransferToken() {
  const token = localStorage.getItem('transferToken')
  return token 
}


const request = axios.create({})
request.defaults.timeout = 1000 * 1000
/*
| 'arraybuffer'
  | 'blob'
  | 'document'
  | 'json'
  | 'text'
  | 'stream'
*/
// request.defaults.responseType = "arraybuffer"//arraybuffer
// // request.defaults.baseURL = '/api'
// request.interceptors.request.use( config => {
//   const token = isAdmin ? getTransferToken() : getToken();
//   config.headers['Authorization'] = "Bearer " + token
//   return config
// },
// err => {
//   return Promise.reject(err)
// })


export function getJSONData(urlStr: string) {
  return  new Promise((resolve, reject) => {
    console.log('url = ', urlStr)
    return axios.get(urlStr , {
      responseType: 'blob',
    }).then(response => {
          console.log('----response = ', response)
          resolve(response.data);
          return response.data
      }).catch(error => {
          reject(error);
          // 异常处理
      })
  })
}

export function getUrlData(urlStr: string, isJson: boolean = true) {
  const type = isJson ? 'json' : 'arraybuffer'
  return  new Promise((resolve, reject) => {
    return axios.get(urlStr, {
      responseType: type,
    }
      ).then(response => {
          console.log('----response = ', response)
          resolve(response.data);
          return response.data
      }).catch(error => {
          reject(error);
          // 异常处理
      })
  })
}
